module.exports = __webpack_public_path__ + "img/944-2573ee.png";